/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountType {
  Adaptr = "Adaptr",
  Feed = "Feed",
}

/**
 * Possible application modes (this might be obsolete)
 */
export enum AppMode {
  development = "development",
  inactive = "inactive",
  live = "live",
  suspended = "suspended",
  unknown = "unknown",
}

export enum ApplicationInstanceSetSortableFields {
  dirtiedDate = "dirtiedDate",
  dirtyApplicationStationCount = "dirtyApplicationStationCount",
  dirtyAudioFileCount = "dirtyAudioFileCount",
  name = "name",
}

export enum ApplicationInstanceType {
  Development = "Development",
  Production = "Production",
}

/**
 * State of application. Defaults to 'development'. The
 * 'uknown' mode will ultimately be removed.
 */
export enum ApplicationMode {
  development = "development",
  inactive = "inactive",
  live = "live",
  suspended = "suspended",
  unknown = "unknown",
}

/**
 * The mode that a given entity uses to determine country availability.
 */
export enum CountryInclusionMode {
  exclude = "exclude",
  exclude_all = "exclude_all",
  include = "include",
  include_all = "include_all",
}

export enum CyaniteEnergy {
  high = "high",
  low = "low",
  medium = "medium",
  variable = "variable",
}

/**
 * DDEX message type
 */
export enum DDEXMessageType {
  OriginalMessage = "OriginalMessage",
  UpdateMessage = "UpdateMessage",
}

export enum DirtyAudioFilesSortableFields {
  artist = "artist",
  dirtiedDate = "dirtiedDate",
  dirtyApplicationCount = "dirtyApplicationCount",
  dirtyApplicationInstanceSetCount = "dirtyApplicationInstanceSetCount",
  dirtyApplicationStationCount = "dirtyApplicationStationCount",
  dirtyStationCount = "dirtyStationCount",
  release = "release",
  track = "track",
}

export enum EXPLICIT {
  CENSORED = "CENSORED",
  CLEAN = "CLEAN",
  EXPLICIT = "EXPLICIT",
  UNKNOWN = "UNKNOWN",
}

export enum ExplicitnessRating {
  G = "G",
  NC17 = "NC17",
  PG = "PG",
  PG13 = "PG13",
  R = "R",
  unknown = "unknown",
}

/**
 * FileDomain tells the server which bucket to put the uploaded file into
 */
export enum FileDomain {
  AUDIO = "AUDIO",
  FILTER_ASSETS = "FILTER_ASSETS",
  FITNESS_STREAMING_ASSETS = "FITNESS_STREAMING_ASSETS",
  INSTRUCTED_FITNESS_ASSETS = "INSTRUCTED_FITNESS_ASSETS",
  REPORTING_ASSETS = "REPORTING_ASSETS",
  STATION_ASSETS = "STATION_ASSETS",
}

export enum HitCountStrategy {
  DONT_COUNT = "DONT_COUNT",
  TRACK_TOTAL_HITS = "TRACK_TOTAL_HITS",
  UP_TO_TEN_K = "UP_TO_TEN_K",
}

/**
 * A sort order
 */
export enum OrderBy {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * Target for publishing a station
 */
export enum PublishingTarget {
  DevOnly = "DevOnly",
  ProdAndDev = "ProdAndDev",
}

export enum RepairAudioFileInStationsAction {
  REMOVE = "REMOVE",
  REPLACE = "REPLACE",
}

export enum RepairAudioFileInStationsPostAction {
  MARK_READY = "MARK_READY",
  NONE = "NONE",
}

export enum ReportPeriod {
  daily = "daily",
  halfYearly = "halfYearly",
  monthly = "monthly",
  quarterly = "quarterly",
  weekly = "weekly",
  yearly = "yearly",
}

export enum ReportSortableFields {
  created = "created",
  name = "name",
  nextPeriodDueDate = "nextPeriodDueDate",
}

export enum StationEventLogType {
  CommentAdded = "CommentAdded",
  StationCopied = "StationCopied",
  StationUpdated = "StationUpdated",
  TrackAdded = "TrackAdded",
  TrackRemoved = "TrackRemoved",
  TrackTrimsAdjusted = "TrackTrimsAdjusted",
  TracksReordered = "TracksReordered",
}

export enum StationIntensity {
  high = "high",
  low = "low",
  medium = "medium",
}

/**
 * Sortable fields.
 */
export enum StationRequestSortableFields {
  appName = "appName",
  assigneeEmailAddress = "assigneeEmailAddress",
  assigneeFirstname = "assigneeFirstname",
  assigneeLastname = "assigneeLastname",
  created = "created",
  deadlineLive = "deadlineLive",
  deadlinePublish = "deadlinePublish",
  deadlineQa = "deadlineQa",
  lastComment = "lastComment",
  lastCommentDate = "lastCommentDate",
  lastEditDate = "lastEditDate",
  name = "name",
  status = "status",
}

export enum StationRequestType {
  firstplay = "firstplay",
  replay = "replay",
}

export enum StationSortableFields {
  badBlipCount = "badBlipCount",
  blipCount = "blipCount",
  countryInclusionMode = "countryInclusionMode",
  created = "created",
  creator = "creator",
  hidden = "hidden",
  id = "id",
  indexInPlacement = "indexInPlacement",
  lastUpdated = "lastUpdated",
  name = "name",
  onDemand = "onDemand",
  preGain = "preGain",
  shuffle = "shuffle",
  singlePlay = "singlePlay",
  status = "status",
  statusUpdated = "statusUpdated",
  totalDurationInSeconds = "totalDurationInSeconds",
}

/**
 * Possible Station statuses
 */
export enum StationStatus {
  awaiting_feedback = "awaiting_feedback",
  awaiting_purchase_build = "awaiting_purchase_build",
  awaiting_purchase_request = "awaiting_purchase_request",
  awaiting_purchase_samples = "awaiting_purchase_samples",
  build = "build",
  curator_assistance = "curator_assistance",
  developing_samples = "developing_samples",
  distributed = "distributed",
  distributing = "distributing",
  failed_to_distribute = "failed_to_distribute",
  failed_to_publish = "failed_to_publish",
  failed_to_unpublish = "failed_to_unpublish",
  failed_to_unpublish_and_delete = "failed_to_unpublish_and_delete",
  in_qa = "in_qa",
  join_next_publish_to_development = "join_next_publish_to_development",
  join_next_publish_to_production = "join_next_publish_to_production",
  join_next_unpublish = "join_next_unpublish",
  join_next_unpublish_and_delete = "join_next_unpublish_and_delete",
  needs_qa = "needs_qa",
  published = "published",
  published_to_development = "published_to_development",
  published_to_production = "published_to_production",
  publishing = "publishing",
  qa_ed = "qa_ed",
  unpublished = "unpublished",
  waiting_to_publish = "waiting_to_publish",
}

/**
 * Possible Station types
 */
export enum StationType {
  FirstPlay = "FirstPlay",
  OnDemand = "OnDemand",
  Radio = "Radio",
  Replay = "Replay",
}

export enum StationUpdatedFields {
  cast_id = "cast_id",
  comment = "comment",
  creator_user_id = "creator_user_id",
  hidden = "hidden",
  index_in_placement = "index_in_placement",
  name = "name",
  on_demand = "on_demand",
  options = "options",
  pre_gain = "pre_gain",
  published = "published",
  request_status = "request_status",
  shuffle = "shuffle",
  single_play = "single_play",
  status = "status",
  workflow_status = "workflow_status",
}

export enum TrackSearchSortableFields {
  artist = "artist",
  bpm = "bpm",
  date = "date",
  dateAdded = "dateAdded",
  dirtiedDate = "dirtiedDate",
  dirtyApplicationCount = "dirtyApplicationCount",
  dirtyApplicationInstanceSetCount = "dirtyApplicationInstanceSetCount",
  dirtyApplicationStationCount = "dirtyApplicationStationCount",
  dirtyStationCount = "dirtyStationCount",
  duration = "duration",
  explicit = "explicit",
  gain = "gain",
  rating = "rating",
  release = "release",
  source = "source",
  track = "track",
  year = "year",
}

export enum TrackValidationErrorType {
  DUPLICATE_TRACK_IN_APP = "DUPLICATE_TRACK_IN_APP",
  DUPLICATE_TRACK_IN_STATION = "DUPLICATE_TRACK_IN_STATION",
  INTELLECTUAL_PROPERTY_RESTRICTION = "INTELLECTUAL_PROPERTY_RESTRICTION",
  LEGAL_PRECAUTION = "LEGAL_PRECAUTION",
  NO_MATCH_FOUND = "NO_MATCH_FOUND",
  PERFORMING_RIGHTS_RESTRICTION = "PERFORMING_RIGHTS_RESTRICTION",
  RIGHTSHOLDER_RESTRICTION = "RIGHTSHOLDER_RESTRICTION",
}

export enum ViewType {
  dashboard = "dashboard",
  question = "question",
}

/**
 * Station workflow statuses. These are obsolete, though in use in some places, as this field has been
 * superseded by StationStatus.
 */
export enum WorkflowStatus {
  HIDDEN = "HIDDEN",
  PENDING = "PENDING",
  PUBLISHED = "PUBLISHED",
}

/**
 * Input for internal creation/editing of an Application.
 */
export interface ApplicationAdminFields {
  name?: string | null;
  accountId?: number | null;
  ownerId?: number | null;
  mode?: AppMode | null;
  stationRequestNotification?: string | null;
  nextOptimizationDate?: string | null;
  goLiveDate?: string | null;
  takeDownDate?: string | null;
  monthlyPlayThreshold?: number | null;
  comment?: string | null;
  stationForeignKeyName?: string | null;
  copyStationNameToForeignKey?: boolean | null;
  copyUUIDToForeignKey?: boolean | null;
  soundExchangeId?: number | null;
  defaultPreGain?: number | null;
}

/**
 * Input for fields to update app instances.
 */
export interface ApplicationInstanceFields {
  name?: string | null;
  stationAllotmentFirstPlay?: number | null;
  stationAllotmentReplay?: number | null;
  crossfadeSeconds?: number | null;
  preGain?: number | null;
  rating?: ExplicitnessRating | null;
}

export interface ApplicationInstanceSetFilter {
  name?: string | null;
  hasDirtyAvailabilityExcludingClips?: boolean | null;
  hasDirtyAvailability?: boolean | null;
}

export interface ApplicationInstanceSetSort {
  field: ApplicationInstanceSetSortableFields;
  order: OrderBy;
}

export interface ApplicationRole {
  applicationId?: string | null;
  role: GraphQLRole;
}

export interface ApplicationStationsFilter {
  statuses?: string[] | null;
  singlePlay?: boolean | null;
  onDemand?: boolean | null;
  replay?: boolean | null;
  offline?: boolean | null;
  radio?: boolean | null;
  hasStationRequest?: boolean | null;
  search?: string | null;
  legacyInternationalStreaming?: boolean | null;
  countryAvailability?: CountryFilter | null;
  tracks?: number | null;
  creators?: number[] | null;
  published?: boolean | null;
  unpublishedChanges?: boolean | null;
  hasLiveDirtyRights?: boolean | null;
  productId?: number | null;
  musicCatalogId?: number | null;
  tags?: string[] | null;
  reorderableStations?: boolean | null;
  excludeUnsubmittedRequests?: boolean | null;
}

export interface AudioFileAvailabilityInput {
  streamingRight: string;
  countryAvailability: CountryAvailabilityCompleteInput;
}

/**
 * Form for updating audio file data
 */
export interface AudioFileForm {
  duration_in_seconds?: number | null;
  year?: number | null;
  bpm?: number | null;
  placeholder?: boolean | null;
  acquire_notes?: string | null;
  acquire_url?: string | null;
  isrc?: string | null;
  label?: string | null;
  pline?: string | null;
  filename?: string | null;
  extra?: string | null;
  explicit?: EXPLICIT | null;
  explicit_source?: string | null;
  explicit_verified?: boolean | null;
  rating?: ExplicitnessRating | null;
}

/**
 * Input for updating a content source's DDEX field mapping.
 */
export interface ContentSourceRightsMappingInput {
  commercialModelType: string;
  useType: string;
  streamingRightIds: number[];
}

export interface CountryAvailabilityCompleteInput {
  mode: CountryInclusionMode;
  countriesAndDates: CountryDateInput[];
  start?: GraphQLDate | null;
  stop?: GraphQLDate | null;
}

/**
 * Object for supplying a (simplified) country availability policy as input.
 */
export interface CountryAvailabilityInput {
  mode?: CountryInclusionMode | null;
  countryIsoCodes: string[];
}

export interface CountryDateInput {
  country: CountryIsoInput;
  start?: GraphQLDate | null;
  stop?: GraphQLDate | null;
}

export interface CountryFilter {
  countryInclusionMode?: CountryInclusionMode | null;
  countryCodes?: string[] | null;
  matchExact?: boolean | null;
}

export interface CountryIsoInput {
  code: string;
}

export interface CreateAudioFileSourceInput {
  name: string;
  ddexPartyId?: string | null;
  pricePerPlay?: number | null;
}

export interface CreateMetabaseViewForm {
  dashboard_id: number;
  name: string;
  description?: string | null;
  type: ViewType;
}

export interface DateRange {
  startDate?: GraphQLDate | null;
  endDate?: GraphQLDate | null;
}

export interface DirtyAudioFilesFilters {
  excludeClips?: boolean | null;
}

export interface DirtyAudioFilesSort {
  field: DirtyAudioFilesSortableFields;
  order: OrderBy;
}

export interface FloatRange {
  minimum?: number | null;
  maximum?: number | null;
}

/**
 * Represents a range as Int values. The minimum and maximum values are inclusive, so a maximum of 10
 * describes a range that includes the number 10, but not 11. If minimum is omitted, there is no lower
 * boundary to this range. If maximum is omitted, there is no upper boundary.
 */
export interface IntRange {
  minimum?: number | null;
  maximum?: number | null;
}

export interface ItunesResult {
  artistName?: string | null;
  artworkUrl60?: string | null;
  artworkUrl100?: string | null;
  collectionName?: string | null;
  collectionPrice?: number | null;
  previewUrl?: string | null;
  trackCensoredName?: string | null;
  trackExplicitness?: string | null;
  trackId?: string | null;
  trackName?: string | null;
  trackPrice?: number | null;
  trackTimeMillis?: number | null;
  trackViewUrl?: string | null;
  wrapperType?: string | null;
}

/**
 * Itunes Search support
 */
export interface ItunesResults {
  resultCount: number;
  results: ItunesResult[];
}

/**
 * Pagination configuration for a request
 */
export interface Pagination {
  page: number;
  perPage: number;
}

export interface RepairAudioFileInStationsStation {
  stationId: number;
  action: RepairAudioFileInStationsAction;
}

export interface ReportForm {
  name: string;
  instructions: string;
  nextPeriodStartDate?: GraphQLDate | null;
  nextPeriodEndDate?: GraphQLDate | null;
  nextPeriodDueDate?: GraphQLDate | null;
  period: ReportPeriod;
  gracePeriodInDays: number;
  applyToNewApps: boolean;
  reportFormatter?: string | null;
  territoryId: number;
}

export interface ReportLinkForm {
  title: string;
  url: string;
}

export interface ReportSort {
  field: ReportSortableFields;
  order: OrderBy;
}

export interface ReportsFilter {
  name?: string | null;
}

/**
 * Input for internal creation/editing of a Station.
 */
export interface StationAdminFields {
  name?: string | null;
  creatorUserId?: number | null;
  comment?: string | null;
  crossfadeSeconds?: number | null;
  indexInPlacement?: number | null;
  castID?: string | null;
  workflowStatus?: WorkflowStatus | null;
  preGain?: number | null;
  onDemandPlayback?: boolean | null;
  shuffleSongOrder?: boolean | null;
  singlePlay?: boolean | null;
  hidden?: boolean | null;
  productId?: number | null;
  musicCatalogId?: number | null;
  genreId?: number | null;
  intensity?: StationIntensity | null;
  rating?: ExplicitnessRating | null;
  streamingRightsCollectionId?: number | null;
  tags?: string[] | null;
  options?: GraphQLJsonString | null;
  sourceStationId?: number | null;
}

/**
 * Input for updating a station in bulk operations.
 */
export interface StationAdminUpdate {
  stationId: number;
  countryAvailability?: CountryAvailabilityInput | null;
  fields: StationAdminFields;
}

/**
 * Defines a station distribution operation.
 */
export interface StationDistributionOperation {
  sinkStationId: number;
  publish?: PublishingTarget | null;
}

export interface StationRequestOptionsForm {
  warmupEndSeconds?: number | null;
  cooldownStartSeconds?: number | null;
  mainTimeSeconds?: number | null;
  crossfadeSeconds?: number | null;
  includeFirstSongDuration?: boolean | null;
  canOverride?: boolean | null;
  addCooldown?: boolean | null;
  addWarmup?: boolean | null;
  enableExplicit?: boolean | null;
  itunesExplicit?: boolean | null;
  qaDays?: number | null;
  publishDays?: number | null;
  liveDays?: number | null;
  streamingRightsCollectionId?: number | null;
  rating?: ExplicitnessRating | null;
}

/**
 * Filters for searching for station requests
 */
export interface StationRequestSearchFilter {
  appIds?: GraphQLApplicationID[] | null;
  assignedTo?: (GraphQLUserID | null)[] | null;
  assignableToMe?: boolean | null;
  stationIds?: (GraphQLStationID | null)[] | null;
  statuses?: (string | null)[] | null;
}

/**
 * Station request sort options
 */
export interface StationRequestSort {
  field: StationRequestSortableFields;
  order: OrderBy;
}

/**
 * Station request update details
 */
export interface StationRequestUpdateForm {
  qaDate?: GraphQLDateTime | null;
  publishDate?: GraphQLDateTime | null;
  liveDate?: GraphQLDateTime | null;
}

export interface StationSort {
  field: StationSortableFields;
  order: OrderBy;
}

export interface StationsFilter {
  statuses?: string[] | null;
  singlePlay?: boolean | null;
  onDemand?: boolean | null;
  replay?: boolean | null;
  offline?: boolean | null;
  radio?: boolean | null;
  hasStationRequest?: boolean | null;
  search?: string | null;
  legacyInternationalStreaming?: boolean | null;
  countryAvailability?: CountryFilter | null;
  tracks?: number | null;
  creators?: number[] | null;
  tags?: string[] | null;
  hasUndistributedChanges?: boolean | null;
  productId?: number | null;
  musicCatalogId?: number | null;
  reorderableStations?: boolean | null;
}

export interface SubmittedReportFileForm {
  title: string;
  url: string;
}

export interface SubmittedReportForm {
  summary: string;
  notes: string;
  periodStartDate: GraphQLDate;
  periodEndDate: GraphQLDate;
}

export interface TrackSearchCyaniteFilters {
  bpm?: IntRange | null;
  genres?: string[] | null;
  subgenres?: string[] | null;
  musicalEras?: string[] | null;
  energy?: CyaniteEnergy[] | null;
}

export interface TrackSearchFilters {
  requestType?: StationRequestType | null;
  feedArtistId?: number | null;
  durationMilliseconds?: IntRange | null;
  year?: IntRange | null;
  sources?: string[] | null;
  tags?: string[] | null;
  rating?: ExplicitnessRating[] | null;
  explicit?: string[] | null;
  gain?: FloatRange | null;
  date?: DateRange | null;
  bpm?: IntRange | null;
  genres?: string[] | null;
  cyanite?: TrackSearchCyaniteFilters | null;
  hasDirtyAvailabilityBefore?: GraphQLDateTime | null;
  streamableToCountries?: string[] | null;
  streamingRights?: string[] | null;
  stationId?: number | null;
}

export interface TrackSearchSort {
  field: TrackSearchSortableFields;
  order: OrderBy;
}

export interface UpdateContentSourceInput {
  pricePerPlay?: number | null;
  defaultRights?: AudioFileAvailabilityInput[] | null;
  rightsMappings?: ContentSourceRightsMappingInput[] | null;
  ddexPartyId?: string | null;
}

/**
 * Data for creating/editing a user
 */
export interface UserForm {
  firstName: string;
  lastName: string;
  password?: string | null;
  emailAddress: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
